var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"getStoreName"},[_c('el-button',{staticClass:"subBtn",attrs:{"type":"primary"},on:{"click":_vm.returnPickingconfirmation}},[_vm._v("我已选择")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }